import React from 'react';

interface ReconciliationSummaryProps {
  totalExport: number;
  totalImport: number;
  netExport: number;
  syncIssuesCount: number;
}

export const ReconciliationSummary: React.FC<ReconciliationSummaryProps> = ({
  totalExport,
  totalImport,
  netExport,
  syncIssuesCount
}) => {
  const metrics = [
    {
      label: 'Total Export',
      value: totalExport,
      unit: 'kWh',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      label: 'Total Import',
      value: totalImport,
      unit: 'kWh',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50'
    },
    {
      label: 'Net Export',
      value: netExport,
      unit: 'kWh',
      color: netExport >= 0 ? 'text-green-600' : 'text-red-600',
      bgColor: netExport >= 0 ? 'bg-green-50' : 'bg-red-50'
    },
    {
      label: 'Sync Issues',
      value: syncIssuesCount,
      unit: 'days',
      color: syncIssuesCount === 0 ? 'text-green-600' : 'text-red-600',
      bgColor: syncIssuesCount === 0 ? 'bg-green-50' : 'bg-red-50'
    }
  ];

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Energy Reconciliation</h3>
      
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {metrics.map((metric, index) => (
          <div key={index} className={`p-4 rounded-lg ${metric.bgColor}`}>
            <div className="text-sm text-gray-600 mb-1">{metric.label}</div>
            <div className={`text-2xl font-bold ${metric.color}`}>
              {typeof metric.value === 'number' ? metric.value.toFixed(1) : metric.value}
            </div>
            <div className="text-xs text-gray-500">{metric.unit}</div>
          </div>
        ))}
      </div>
      
      <div className="mt-4 p-3 bg-gray-50 rounded-lg">
        <div className="text-sm text-gray-600">
          <strong>Net Energy Flow:</strong> {' '}
          {netExport >= 0 
            ? `${netExport.toFixed(1)} kWh exported to grid` 
            : `${Math.abs(netExport).toFixed(1)} kWh imported from grid`
          }
        </div>
      </div>
    </div>
  );
};